import styled from 'styled-components';

import colors from '@constants/colors';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 56px;
  padding: 0 14px;
  background-color: ${colors.NAVY_BLUE_ORIGIN};
`;

export const FloatRightBox = styled.div``;
